<template>
  <div>
    <div class="close-open" @click="closeWindow">
      <i class="el-icon-close"></i>
    </div>
    <div class="title-top-alarm">
      <div>
        <span>电话呼入</span>
      </div>
      <div class="line-title"></div>
    </div>
    <div v-loading="loading" style="min-height: 200px">
      <!--新建服务对象-->
      <div v-if="isShow === 1">
        <div style="font-size: 18px;height: 40px;text-align: center">
          <span>
            呼入电话新建服务对象信息,是否将次号码
            <span v-if="!phoneObj.isTable" style="color: #1684fc">{{phoneObj.alarmMsg.phone}}</span>
            <span v-else style="color: #1684fc">{{phoneObj.alarmRow.alarmphone}}</span>
            录入为联系方式？
          </span>
          <el-button size="mini" type="primary" plain @click="getPhonePerson()">是</el-button>
        </div>
        <old-person v-if="!loading" ref="oldPerson" :personObj="personObj" @getFather="getFather"></old-person>
      </div>
      <!--查询已有的对象-->
      <div v-if="isShow === 2">
        <phonein-old-person-list v-if="!loading" :phoneListObj="phoneListObj" @getFatherList="getFatherList"></phonein-old-person-list>
      </div>
      <!--处理报警-->
      <div v-if="isShow === 3">
        <do-handle-alarm :handleAlarmRow="changeRow"  @getFatherHandle="getFatherHandle"></do-handle-alarm>
      </div>
    </div>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {queryfrequency, queryproject} from '../../api/serviceObject'
import {
  querysuppliertype,
  querysupplierorgnotype,
  querysupplierservice
} from '../../api/serviceMark'
import {sendSub} from '../../mq'
import {getUsername} from '../../utils/auth'
import {makePhoneCall} from '../../sip/sip_index'
import {queryorgcommunity} from '../../api/community'
import oldPerson from '../../components/datamanagement/quick/components/oldPerson'
import phoneinOldPersonList from './phoneinOldPersonList'
import doHandleAlarm from '../../components/datamanagement/childComponents/doHandleAlarm'
export default {
  name: 'phoneInAlarm',
  components: {oldPerson, phoneinOldPersonList, doHandleAlarm},
  model: {
    prop: 'phoneinShow',
    event: 'change'
  },
  props: {
    phoneObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      orgok: false,
      fok: false,
      pjok: false,
      orgOptions: [],
      personObj: {
        phone: '', // 来电号码 显示 下一步 按钮
        orgcommunitys: [],
        orgOptions: [],
        frequencys: [],
        projects: [],
        isAddPerson: true, // 是否是新建服务对象
        isDoAdd: false, // 完成新建服务对象之后再修改
        editRow: {},
        addData: {} // 添加完成之后的表单信息
      },
      phoneListObj: {
        isTable: false,
        alarmRow: '',
        alarmMsg: '',
        frequencys: [],
        projects: [],
        listTable: []
      },
      changeRow: {
        isPhonein: true,
        oldPerson: '',
        row: {},
        types: [],
        supplierorg: [],
        typeOrg: [],
        projects: [],
        frequencys: [],
        orgcommunitys: []
      },
      isShow: '' // 1 新建服务对象 2 选择服务对象 3 报警弹窗
    }
  },
  created () {
    // console.log(999, this.phoneObj)
    this.phoneListObj.isTable = this.phoneObj.isTable // 是否为表格
    this.phoneListObj.alarmRow = this.phoneObj.alarmRow // 表格
    this.phoneListObj.alarmMsg = this.phoneObj.alarmMsg // mqtt
    this.getFrequency()
    let name = this.$store.state.user.personname
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('hh:mm:ss')
    let mqtts = this.$store.state.user.mqtts
    let jobnum = this.$store.state.user.syspersonjobnum
    if (this.phoneObj.isTable) {
      let dohandle = {id: this.phoneObj.alarmRow.id, name: name, time: date, jobnum: jobnum}
      sendSub('/handlealarm' + mqtts[0], JSON.stringify(dohandle))
      this.getStartData()
    } else {
      let dohandle = {id: parseInt(this.phoneObj.alarmMsg.alarmid), name: name, time: date, jobnum: jobnum}
      sendSub('/handlealarm' + mqtts[0], JSON.stringify(dohandle))
      this.changeRow.row = this.phoneObj.alarmMsg
      this.changeRow.row.id = parseInt(this.phoneObj.alarmMsg.alarmid)
      this.personObj.phone = this.phoneObj.alarmMsg.phone
      this.getCommunityData()
    }
  },
  methods: {
    closeWindow () {
      let name = this.$store.state.user.personname
      let jobnum = this.$store.state.user.syspersonjobnum
      let dohandle = {id: '', name: name, jobnum: jobnum}
      if (this.phoneObj.isTable) {
        dohandle.id = this.phoneObj.alarmRow.id
      } else {
        dohandle.id = parseInt(this.phoneObj.alarmMsg.alarmid)
      }
      let mqtts = this.$store.state.user.mqtts
      sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
      this.store2.dispatch('other/update_del_alarm', dohandle.id).then(() => {
        if (this.$route.path === '/handleAlarm') {
          this.golobleObject.updateTableAlarm()
        }
      })
      this.$emit('change', false)
    },
    editCallPhone (phoneNum) {
      if (phoneNum.slice(0, 3) === '021') {
        return
      }
      let mqtts = this.$store.state.user.mqtts
      sendSub('callphone' + mqtts[0], this.alarmid + ';' + getUsername() + ';1')
      makePhoneCall(phoneNum)
      this.$notify({
        title: '成功',
        message: '正在呼叫，请注意接听电话，用以呼叫',
        type: 'success',
        duration: 1000
      })
      if (this.phoneListObj.listTable.length > 0) {
        this.isShow = 2
      } else {
        this.isShow = 1
      }
    },
    // 表格处理电话呼入
    getStartData () {
      this.changeRow.row = this.phoneObj.alarmRow
      this.changeRow.types = this.phoneObj.types
      this.changeRow.supplierorg = this.phoneObj.supplierorg
      this.changeRow.typeOrg = this.phoneObj.typeOrg
      this.changeRow.orgcommunitys = this.phoneObj.orgcommunitys
      this.changeRow.projects = this.phoneObj.projects
      this.personObj.projects = this.phoneObj.projects
      this.phoneListObj.projects = this.phoneObj.projects
      this.pjok = true
      this.personObj.phone = this.phoneObj.alarmRow.alarmphone
      this.personObj.orgcommunitys = this.phoneObj.orgcommunitys
      // this.getOldPersonTableByPhone()
      this.getIsOk()
    },
    // 组织
    getOrgData () {
      queryorg().then(res => {
        this.orgok = true
        this.getIsOk()
        // 所属组织
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.orgOptions.push(arr[i])
          }
        }
        for (let i = 0; i < this.orgOptions.length; i++) {
          const child = this.arrayToNode(arr, this.orgOptions[i].id)
          if (child.length !== 0) {
            this.orgOptions[i].child = child
          }
        }
        this.personObj.orgOptions = this.orgOptions
        this.$refs.oldPerson.getParentOrgData(this.orgOptions)
      }).catch(() => {})
    },
    // 递归
    arrayToNode (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 查询频率
    getFrequency () {
      this.loading = true
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryfrequency(data).then(res => {
        this.getOrgData()
        this.personObj.frequencys = res.data.frequencys
        this.phoneListObj.frequencys = res.data.frequencys
        this.changeRow.frequencys = res.data.frequencys
        this.fok = true
        this.getIsOk()
      }).catch(() => {
        this.loading = false
      })
    },
    // 所属小区
    getCommunityData () {
      queryorgcommunity().then(res => {
        this.querySupplier()
        this.changeRow.orgcommunitys = res.data.orgcommunitys
        this.personObj.orgcommunitys = res.data.orgcommunitys
      }).catch(() => {})
    },
    // 服务商
    querySupplier () {
      let params = {
        page: 1,
        size: 9999
      }
      querysupplierorgnotype(params).then(res => {
        this.changeRow.supplierorg = res.data.org
        this.querySupplierType()
      }).catch(() => {})

      // querysupplierorg().then(res => {
      //   this.changeRow.supplierorg = res.data.org
      //   this.querySupplierType()
      // }).catch(() => {})
    },
    // 服务类型
    querySupplierType () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.changeRow.types = res.data.types
        this.querySupplierAndType()
      }).catch(() => {})

      // querysuppliertype().then(res => {
      //   this.changeRow.types = res.data.types
      //   this.querySupplierAndType()
      // }).catch(() => {})
    },
    // 服务内容
    querySupplierAndType () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierservice(params).then(res => {
        this.changeRow.typeOrg = res.data.service
        this.getProjects()
      }).catch(() => {})

      // querysuppliertypeorg().then(res => {
      //   this.changeRow.typeOrg = res.data.type_org
      //   this.getProjects()
      // }).catch(() => {})
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryproject(data).then(res => {
        this.personObj.projects = res.data.projects
        this.phoneListObj.projects = res.data.projects
        this.changeRow.projects = res.data.projects
        this.pjok = true
        this.getIsOk()
        // this.getOldPersonTableByPhone()
      }).catch(() => {
        this.loading = false
      })
    },
    getIsOk () {
      if (this.orgok && this.fok && this.pjok) {
        this.loading = false
        this.isShow = 2
      }
    },
    getPhonePerson () {
      this.$refs.oldPerson.getPhone()
    },
    getFather (obj) { // 新建服务对象调用父级方法
      if (obj.type === 'handle') {
        // console.log(obj)
        this.changeRow.oldPerson = obj.addEditForm
        this.isShow = 3
      }
    },
    getFatherList (obj) {
      // console.log(obj)
      if (obj.type === 'next') {
        this.changeRow.oldPerson = obj.row
        this.isShow = 3
      } else if (obj.type === 'add') {
        this.isShow = 1
      } else if (obj.type === 'close') {
        this.$emit('change', false)
      }
    },
    getFatherHandle (obj) {
      if (obj.type === 'close') {
        this.$emit('change', false)
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/components/phoneInAlarm.vue